import { useEffect } from 'react';
import { furniture, furnitureById } from '../../../data/config';
import { useGameStore } from '../../../store/gameStore';
import { useUiStore } from '../../../store/uiStore';

export function HomePanel() {
  const home = useGameStore((state) => state.game.home);
  const player = useGameStore((state) => state.game.player);
  const actions = useGameStore((state) => state.actions);
  const selectedId = useUiStore((state) => state.selectedFurnitureInstanceId);
  const showNotice = useUiStore((state) => state.showNotice);

  useEffect(() => {
    if (!home.draftPlacements) actions.beginDecorating();
  }, [actions, home.draftPlacements]);

  const placements = home.draftPlacements ?? home.placements;
  const owned = furniture.filter((item) => (home.ownedFurniture[item.id] ?? 0) > 0);

  return (
    <section className="control-panel" data-tutorial-target="home-decorating">
      <div className="panel-heading">
        <h2>装修模式 · 房屋 Lv.{home.houseLevel}</h2>
        <button
          className="secondary-button"
          onClick={() => {
            const result = actions.upgradeHouse();
            showNotice(result.ok ? '房屋升级成功！' : result.message);
          }}
        >
          升级房屋
        </button>
      </div>
      <div className="chip-list">
        {owned.map((item) => {
          const used = placements.filter((placement) => placement.furnitureId === item.id).length;
          const count = home.ownedFurniture[item.id] ?? 0;
          return (
            <button
              key={item.id}
              className="chip"
              disabled={used >= count}
              onClick={() => {
                const result = actions.placeFurniture(item.id);
                if (!result.ok) showNotice(result.message);
              }}
            >
              {item.name.split('·')[1]} {count - used}/{count}
            </button>
          );
        })}
      </div>
      <div className="action-row">
        <button
          disabled={!selectedId}
          onClick={() => {
            if (!selectedId) return;
            const result = actions.rotateFurniture(selectedId);
            if (!result.ok) showNotice(result.message);
          }}
        >
          旋转家具
        </button>
        <button
          disabled={!selectedId}
          onClick={() => selectedId && actions.removeFurniture(selectedId)}
        >
          收回家具
        </button>
        <button className="primary-button" onClick={() => actions.commitDecorating()}>
          保存装修
        </button>
        <button
          onClick={() => {
            actions.cancelDecorating();
            actions.beginDecorating();
          }}
        >
          撤销更改
        </button>
      </div>
      <p className="hint">
        拖动家具改变位置，点击家具后可以旋转或收回。当前金币：{player.coins}。
        {selectedId
          ? ` 已选择：${furnitureById.get(placements.find((item) => item.instanceId === selectedId)?.furnitureId ?? '')?.name ?? '家具'}`
          : ''}
      </p>
    </section>
  );
}
